import { crud } from "./crud";
import { httpPost } from "../services/http";

const defaultState = [];

export const data = (state = defaultState, action) => crud('data', state, action);

export const getData = (skip) => {
	return (dispatch) => {
		httpPost('/data/getAll', { skip }).then(data => {
			dispatch({
				type: 'data_add',
				data: data
			})
		});
	}
};